import React from 'react';
import { Bar } from 'react-chartjs-2';
import { COLORS } from '../../constants/constants';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,  // Use BarElement for Bar charts
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

// Register the necessary components for Bar chart
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,   // Register BarElement for bar chart rendering
  Title,
  Tooltip,
  Legend
);

const BarChartComponent = ({ data }) => {
  const options = {
    responsive: true,
    scales: {
      y: {
        beginAtZero: true, // Ensure the y-axis starts from zero
      },
      x: {
        // Configure x-axis ticks (labels)
        ticks: {
          autoSkip: false,  // Disable auto skipping for labels
          font: {
            size: 12, // Label font size
            weight: 'bold', // Label font weight
          },
          padding: 10, // Add padding between labels and bars
        },
        // Add space between bars
        barPercentage: 0.8, // Set the percentage of the available space used by bars (0.8 = 80%)
        categoryPercentage: 0.6, // Set the percentage of space for each category (0.6 = 60%)
      },
    },
    plugins: {
      legend: {
        position: 'bottom', // Position the legend at the bottom
        labels: {
          boxWidth: 20,  // Set the size of the legend box
          padding: 20,   // Add space between the legend items
          font: {
            size: 12, // Customize font size for the legend
            weight: 'bold',
          },
          usePointStyle: true,  // Use circular markers for the legend
        },
      },
      tooltip: {
        enabled: true,  // Enable tooltips
        backgroundColor: 'rgba(0,0,0,0.8)',  // Tooltip background color
        titleColor: '#fff',  // Title color in tooltip
        bodyColor: '#fff',  // Body text color in tooltip
        footerColor: '#fff',  // Footer text color in tooltip
        callbacks: {
          title: (tooltipItem) => {
            return 'Custom Title: ' + tooltipItem[0].label;  // Custom title
          },
          label: (tooltipItem) => {
            return tooltipItem.dataset.label + ': ' + tooltipItem.raw + '%';  // Customize label
          },
        },
      },
    },
  };
  
  // Assign colors based on the number of datasets
  const datasetColors = data.datasets.length === 2
    ? [COLORS.primary, COLORS.secondary]  // If 2 datasets, use primary and secondary colors
    : [COLORS.profit, COLORS.primary, COLORS.dues]; // If 3 datasets, use custom colors

  // Map colors to the datasets
  const updatedData = {
    ...data,
    datasets: data.datasets.map((dataset, index) => ({
      ...dataset,
      backgroundColor: datasetColors[index] || COLORS.primary, // Set background color for bars
      barThickness: 10, // Set thickness of bars
    })),
  };

  return <Bar data={updatedData} options={options} />;
};

export default BarChartComponent;
